module.exports = __webpack_public_path__ + "img/newspaper.74eac5d1.svg";